import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import * as moment from 'moment-timezone';
import { takeUntil } from 'rxjs/operators';
import { StagingService } from 'src/app/component/assigned-trips/staging/staging.service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { sweetAlert } from 'src/app/utils/swal';

@Component({
  selector: 'app-intake-suggested-time-modal',
  templateUrl: './intake-suggested-time-modal.component.html',
  styleUrls: ['./intake-suggested-time-modal.component.css']
})
export class IntakeSuggestedTimeModalComponent implements OnInit, OnDestroy {
  @Input() trip: any;
  @Output() onCloseModal = new EventEmitter<any>();

  tripForm: FormGroup;
  user;
  timeZone;

  constructor(
    private fb: FormBuilder,
    private stagingService: StagingService,
    private sharedDataService: SharedDataService,
  ) { }

  ngOnInit() {
    this.tripForm = this.fb.group({
      _id: this.trip._id,
      intakeStatus: ["suggested_time"],
      preIntakeSuggestedTime: [""],
      intakeSuggestedTime: ["", Validators.required],
    });
    this.getUser();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.timeZone = this.user.company ? this.user.company.timeZone : this.user.timeZone;
          
          if (this.trip.intakeSuggestedTime) {
            this.tripForm.patchValue({
              preIntakeSuggestedTime: this.trip.intakeSuggestedTime,
              intakeSuggestedTime: this.trip.intakeSuggestedTime
            });
          } else {
            this.tripForm.patchValue({
              preIntakeSuggestedTime: this.trip.scheduleTime,
              intakeSuggestedTime: this.trip.scheduleTime
            });
          }

        }
      });
  }

  onSuggestedTimeChange(evt) {
    this.tripForm.patchValue({
      intakeSuggestedTime: moment(evt).tz(this.timeZone, true).toISOString(),
    });
  }

  save() {
    if (this.tripForm.invalid) {
      sweetAlert("Warning", "Please select a valid suggested time", "warning", "Ok");
      return;
    }
    const formVal = this.tripForm.value;
    const tripId = this.trip._id || this.trip.id;
    const payload = {
      intakeStatus: "suggested_time",
      intakeSuggestedTime: formVal.intakeSuggestedTime
    };

    this.stagingService
      .updateMemberLinkRequest(tripId, payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        const result = Object.assign({
          _id: tripId,
          intakeStatus: "suggested_time",
          intakeSuggestedTime: formVal.intakeSuggestedTime
        }, data || {});
        this.onCloseModal.emit(result);
      }, err => {
        const errorMsg = (err && err.message) ? err.message : (err || 'Failed to suggest time');
        sweetAlert("Error", errorMsg, "error", "Ok");
      });
  }

  close() {
    this.onCloseModal.emit();
  }

  ngOnDestroy() {
  }
}
